/* Copyright 2013 - 2024 Waiterio LLC */
import { Provider } from '@monorepool/context/index.jsx'
import getSentryBrowser from '@monorepool/telemetry/getSentryBrowser.js'
import { initMultilocale } from '@multilocale/react/index.jsx'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ErrorBoundary from '@waiterio/components/ErrorBoundary.jsx'
import ScrollToTop from '@waiterio/components/ScrollToTop.jsx'
import StageBadge from '@waiterio/components/StageBadge.jsx'
import { Suspense } from 'react'
import { hydrateRoot } from 'react-dom/client' // eslint-disable-line import/extensions
import { BrowserRouter } from 'react-router'
import getInitialContext from './getInitialContext.js'
import Routes from './Routes.jsx'
import GlobalStyles from './styles/GlobalStyles.jsx'

const initialContext = window.__PRELOADED_CONTEXT__ || getInitialContext()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
    },
  },
})

initMultilocale({
  organizationId: 'e395dba6a14d8af4c2d35890',
  project: 'waiterio-takeaway',
})

hydrateRoot(
  document.getElementById('root'),
  <ErrorBoundary>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Provider initialContext={initialContext}>
          <Suspense fallback={<p>loading</p>}>
            <ScrollToTop />
            <GlobalStyles />
            <Routes />
            <StageBadge />
          </Suspense>
        </Provider>
      </QueryClientProvider>
    </BrowserRouter>
  </ErrorBoundary>,
)

getSentryBrowser()
